
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import StepContent from "@/components/common/StepContent.vue"
import EnterTitle from "@/components/products/railway/steps/EnterTitle.vue"
import RailwayImageUpload from "@/components/products/railway/steps/RailwayImageUpload.vue"
import EnterDedication from "@/components/products/railway/steps/EnterDedication.vue"

@Component({
  name: 'step-content',
  components: {
      EnterTitle,
      RailwayImageUpload,
      EnterDedication
  }
})
export default class StepContentImpl extends StepContent {
    onCancel() {
        this.$emit('cancel')
    }
    onConfirm() {
        this.$emit('confirm')
    }
    onError(message:string) {
        this.$emit('error', message)
    }
    goToMenu() {
        return this.$refs.activeComponent.goToMenu()
    }
}
